import { PROJECT_DETAILS } from "shared/constants/permalinks"
import { useHref } from "shared/lib/useHref"

export function useProjectDetailsHref(projectID: string) {
  return useHref(`/${PROJECT_DETAILS}?project_id=${projectID}`)
}
